import { Injectable } from '@angular/core';
import { Action, Store as NgrxStore } from '@ngrx/store';
import { activeCategorySelector, activeSubCategorySelector, categoriesSelector, subCategoriesSelector } from './app.selector';
import { TABLE_INFO } from './app.action';
import { filter } from 'rxjs/operators';
import { ActionItem, TableInformation } from '@mysrc/models/approval-hub.model';

@Injectable({
  providedIn: 'root',
})
export default class Store {
  constructor(private readonly store: NgrxStore) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  selectCategory(name: string) {
    this.dispatch(TABLE_INFO.selectCategory({ name }));
  }

  selectSubCategory(name: string) {
    this.dispatch(TABLE_INFO.selectSubCategory({ name }));
  }

  get categories$() {
    return this.store.select(categoriesSelector);
  }

  get subCategories$() {
    return this.store.select(subCategoriesSelector).pipe(filter(d => !!d.length));
  }

  get activeCategory$() {
    return this.store.select(activeCategorySelector);
  }

  get activeSubCategory$() {
    return this.store.select(activeSubCategorySelector);
  }

  approveActionItem(row: ActionItem, tableInfo: TableInformation) {

  }

}
